module.exports = "ace7644d9f464e785214a9716be1524d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/cancel.png
// module id = 70
// module chunks = 0